import { render, staticRenderFns } from "./CourseCopy.vue?vue&type=template&id=29a95224&scoped=true&"
import script from "./course-copy.js?vue&type=script&lang=js&"
export * from "./course-copy.js?vue&type=script&lang=js&"
import style0 from "./CourseCopy.vue?vue&type=style&index=0&id=29a95224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a95224",
  null
  
)

export default component.exports